import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ActionsCollectionPermissionKeys, ApiDef_Action, DBDef_Action, OrderEditorPermissionKeys, pathwayAction_isInterflow, pathwayAction_isOrder } from '@app/pathway-shared';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
export const dispatch_onActionChanged = new ThunderDispatcherV3('__onActionUpdated');
export class ModuleFE_Action_Class extends ModuleFE_BaseApi {
    _v1;
    __searchFilterMapper = (item) => [item.name];
    permissions;
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: items.map(i => ({ _id: i._id, uiLabel: i.name }))
        }]);
    constructor() {
        super(DBDef_Action, dispatch_onActionChanged);
        this._v1 = {
            createOrderWithVariable: apiWithBody(ApiDef_Action._v1.createOrderWithVariable),
        };
        //permission declerations
        this.permissions = {
            ui: PermissionKey_FE.generatePermissionKeysByLevels(OrderEditorPermissionKeys),
            collection: PermissionKey_FE.generatePermissionKeysByLevels(ActionsCollectionPermissionKeys)
        };
    }
    is = { order: pathwayAction_isOrder, interflow: pathwayAction_isInterflow };
}
export const ModuleFE_Action = new ModuleFE_Action_Class();
//# sourceMappingURL=ModuleFE_Action.js.map